import type { LogoListItemData } from '@beat-venues/common-types';
import { type VariantProps, tv } from 'tailwind-variants';

import { Logo } from '../../atoms';
import type { CommonProps } from '../../types';

import type { JSX } from 'react';

export interface LogoListProps
    extends CommonProps,
        VariantProps<typeof LogoListStyles> {
    items: LogoListItemData[];
}

export const LogoListStyles = tv({
    slots: {
        root: 'grid grid-cols-2 xs:flex gap-8 xl:gap-8 flex-wrap xl:flex-nowrap justify-center',
    },
});

export const LogoList = ({
    className,
    items,
    testId = 'logo-list',
}: LogoListProps): JSX.Element => {
    const { root } = LogoListStyles();
    return (
        <ul className={root({ className })} data-testid={testId}>
            {items &&
                items.map((item) => {
                    return (
                        <li
                            key={item.id}
                            className="flex justify-center max-sm:aspect-[245/60] xl:aspect-[245/60]"
                        >
                            <Logo
                                key={item.id}
                                className="max-h-full max-w-full max-xl:h-10 max-md:h-8 xl:h-9"
                                href={item.url}
                                isInternalLink={true}
                                venueId={item.venueId}
                            />
                        </li>
                    );
                })}
        </ul>
    );
};
